import { getListBrowserStore } from '@ts-private/list-browser';

const userGroupStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'code',
      caption: 'UserGroups.Code',
      type: 'text'
    },
    {
      name: 'name',
      caption: 'UserGroups.Name',
      type: 'text'
    }
  ],
  orderByFields: [
    {
      caption: 'UserGroups.Code',
      value: 'Code'
    },
    {
      caption: 'UserGroups.Name',
      value: 'Name'
    }
  ],
  pager: {
    orderBy: 'Name',
    direction: 'asc'
  }
});

export default userGroupStore;
